import React, { ChangeEvent, useCallback } from 'react';

import { Icon } from '@highlight-ui/icon';
import { TextInput } from '@highlight-ui/input';
import classnames from 'classnames';
import { useId } from '@highlight-ui/utils-hooks';

import styles from './SearchInput.module.scss';

export type SearchInputProps = {
  onKeyDown?: (e: React.KeyboardEvent<HTMLElement>) => void;
  value: string;
  onTextChange: (search: string) => void;
  /** Custom class name */
  className?: string;
  /** Placeholder for search input */
  placeholder?: string;
  searchAutofocus?: boolean;
};

const SearchInput = ({
  placeholder = '',
  className,
  value,
  onTextChange,
  onKeyDown,
  searchAutofocus = true,
}: SearchInputProps) => {
  const id = useId('component-');

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) =>
      onTextChange(event.currentTarget.value),
    [onTextChange],
  );

  return (
    <TextInput
      autoFocus={searchAutofocus}
      className={classnames(styles.wrapperBorder, className)}
      role="search"
      defaultValue={value}
      id={id}
      onChange={handleChange}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      type="search"
      prefix={
        <Icon className={styles.icon} color="icon-subdued" name="search" />
      }
    />
  );
};

SearchInput.displayName = 'SearchInput';

export default SearchInput;
